// Dataset query-key roots (`datasetRefreshToken`) used to fetch and invalidate dataset
// data for UI configs. Kept here (not in dataset.api.ts) so behaviour lists like
// KEEP_PREVIOUS_DATA_QUERY_KEYS can reference them without a circular import.

export const DATASET_INSTRUCTION = 'datasetInstruction'
export const DATASET_FOR_UI_CONFIG = 'datasetForUiConfig'
export const DATASET_FOR_UI_CONFIG_REFRESH_ON_OPTIMIZE = 'datasetForUiConfigRefreshOnOptimize'
export const DATASET_FOR_UI_CONFIG_REFRESH_ON_OPTIMIZE_WIP = 'datasetForUiConfigRefreshOnOptimizeWip'
export const DATASET_FOR_UI_CONFIG_REFRESH_ON_REAL_TIME_OPTIMIZE = 'datasetForUiConfigRefreshOnRealTimeOptimize'
export const DATASET_FOR_UI_CONFIG_REFRESH_FOLLOW_UP = 'datasetForUiConfigRefreshFollowUp'
export const DATASET_FOR_UI_CONFIG_REFRESH_ON_FUEL_PLAN = 'datasetForUiConfigRefreshOnFuelPlan'
export const DATASET_FOR_UI_CONFIG_REFRESH_APPLIED_SETTINGS = 'datasetForUiConfigRefreshAppliedSettings'

// Refresh tokens (datasetRefreshToken) whose dataset tables keep their previous data during a
// refetch instead of emptying into a loading placeholder (which would close an open full
// screen). Add a token here to opt another table into the same behaviour.
export const KEEP_PREVIOUS_DATA_QUERY_KEYS = new Set<string>([
  DATASET_FOR_UI_CONFIG_REFRESH_ON_OPTIMIZE,
  DATASET_FOR_UI_CONFIG_REFRESH_ON_OPTIMIZE_WIP,
])
